/*=============================
=         Form Process        =
=============================*/

// var formMessage = document.getElementById('form-message');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
	form.addEventListener('submit', formProcess);
});

function formProcess(e) {
	if('performance' in window === false)
		return true;

	e.preventDefault();

	var form = this,
		data = new FormData(form),
		button = this.querySelector('button[type="submit"]');

	let	formMessage = form.parentNode.querySelector('#form-message') ;

	button.classList.add('disabled');

	data.append('c_time', performance.now() >= 7000 ? 0 : 1);

	axios.post(form.action, data)
		.then(function(r) {
			Velocity(form, 'slideUp', {duration: 500, delay: 500});
			clearErrors(form);


			formMessage.classList.add('success');
			formMessage.innerHTML = r.data.message;

			if(typeof dataLayer !== 'undefined')
				dataLayer.push({'event': 'FormSubmission'});
		})
		.catch(function (e) {
			setTimeout(function() {
				button.classList.remove('disabled');
			}, 500);

			console.log(e.response.data.errors);

			formMessage.classList.add('error');
			formMessage.innerHTML = e.response.data.message;

			if(e.response.status===422) {
				clearErrors(form);
				setErrors(form, e.response.data.errors);
			}
		});
}

function clearErrors(form) {
	var errors = form.getElementsByClassName('error');

	let	formMessage = form.parentNode.querySelector('#form-message') ;

	for(var e=errors.length - 1; e>=0; e--)
		errors[e].classList.remove('error');

	Velocity(formMessage, 'scroll', {
		duration: 500,
		offset: -header.offsetHeight
	});
}

function setErrors(form, errors) {
	var firstField = false;
	let	formMessage = form.parentNode.querySelector('#form-message') ;

	if(Object.keys(errors).length) {
		var errorsList = document.createElement('ul');

	    formMessage.appendChild(errorsList);
	}

	for(var key in errors) {
		var label = form.querySelector('label[for="'+key+'"]');

		if(label)
			label.parentNode.classList.add('error');

		if(key == 'g-recaptcha-response')
			document.querySelector('.g-recaptcha').classList.add('error');

		var field = form.querySelector('*[name="'+key+'"]');

        field.setAttribute('aria-describedby', key+'_error');

		if(!firstField) {
			field.focus();
			firstField = true;
		}

		var li = document.createElement('li');

        li.setAttribute('id', key+'_error');
        li.innerHTML = errors[key];
        errorsList.appendChild(li);
	}
}